export default __webpack_public_path__ + "static/media/logo_german_white_text.35b480be.png";